import {
  ErrorHandler,
  Injectable
} from '@angular/core';
import { NGXLogger } from 'ngx-logger';
import { StackdriverErrorReporterService } from './stackdriver-error-reporter.service';

@Injectable()
export class StackdriverErrorHandler extends ErrorHandler {

  constructor(
    public stackdriver: StackdriverErrorReporterService,
    public logger: NGXLogger,
  ) {
    super();
    this.logger.info('use StackdriverErrorHandler');
  }

  public handleError(error: any) {
    this.logger.error(error);
    this.stackdriver.report(error).then(r => this.logger.warn('logged', r));
  }

}
